import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'jotai'
import './index.css'
import '@repo/fonts/fontInter.css'
import '@repo/fonts/fontPoppins.css'
import '@repo/fonts/fontPrompt.css'
import '@repo/fonts/fontVariables.css'
import App from './App.tsx'
import { appStore } from './core/store/jotai.store'
import { initFlags } from '@/core/flags/flags'
import { initAnalytics } from '@/core/analytics/analytics'
// Register the bundled country plugins (checkout/payments modules) before render.
import '@/countries'

// Merge any ?ff= feature-flag overrides into storage before the app reads them.
initFlags()

// Loads the provider and seeds user_id from a restored session. No-op without a
// VITE_GTM_ID / VITE_GA4_ID, so local and unconfigured builds send nothing.
initAnalytics()

createRoot(document.getElementById('root')!).render(
    <StrictMode data-testid="main-strict-mode">
        <Provider store={appStore} data-testid="main-provider">
            <App data-testid="main-app" />
        </Provider>
    </StrictMode>
)
